module.exports = __webpack_public_path__ + "img/hnhk.9eb419c1.jpeg";